<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.7071 4.29289L16.6129 4.2097C16.2206 3.90468 15.6534 3.93241 15.2929 4.29289L15.2097 4.3871C14.9047 4.77939 14.9324 5.34662 15.2929 5.70711L18.585 9H7L6.88338 9.00673C6.38604 9.06449 6 9.48716 6 10C6 10.5523 6.44772 11 7 11H21L21.1136 10.994C21.9277 10.9072 22.3097 9.89547 21.7071 9.29289L16.7071 4.29289ZM18.002 14C18.002 13.4477 17.5543 13 17.002 13H3.002L2.88837 13.006C2.07434 13.0928 1.69232 14.1045 2.2949 14.7071L7.2949 19.7071L7.38911 19.7903C7.7814 20.0953 8.34863 20.0676 8.70911 19.7071L8.7923 19.6129C9.09733 19.2206 9.0696 18.6534 8.70911 18.2929L5.417 15H17.002L17.1186 14.9933C17.616 14.9355 18.002 14.5128 18.002 14Z"
    fill="currentColor"
  />
</svg>
